export enum QuickOnboardingSteps {
  CONNECT_EXCHANGE = "Connect Your Exchange",
  CREATE_BOT = "Create Your Bot",
  MONITOR_PROGRESS = "Monitor Your Progress",
}
